module.exports = __webpack_public_path__ + "static/media/tusk.3f2f7a0c.png";